/*
 * @Author: ningbo.kang
 * @Date: 2020-11-17 14:48:12
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-12-28 16:36:45
 * @Description: 描述
 */

import defaultLang from './lang/zh-CN';
import Format from './format';

const format = Format();
let lang = defaultLang;
let i18nHandler = () => undefined;

export const t = function t(path, options) {
  let value = i18nHandler.apply(this, [path, options]);
  if (value !== null && value !== undefined) {
    return value;
  }
  const arr = path.split('.');
  let current = lang;

  for (let i = 0, j = arr.length; i < j; i += 1) {
    const prop = arr[i];
    value = current[prop];
    if (i === j - 1) {
      return format(value, options);
    }
    if (!value) {
      return '';
    }
    current = value;
  }
  return '';
};

export const use = function use(l) {
  if (l) {
    lang = l;
  }
};

export const i18n = function i18n(fn) {
  if (fn) {
    i18nHandler = fn;
  }
};

export default { use, t, i18n };
